import { useQuery } from "@tanstack/react-query";
import { getBandeauAnnonce } from "../services/newApi";

/**
 * Récupère l'annonce publiée à afficher dans le bandeau, ou null s'il n'y en a pas.
 *
 * `enabled: !isReactSnap` est le point critique : sans lui, l'annonce présente au
 * moment du build serait figée dans les fichiers HTML prérendus par react-snap et
 * continuerait de s'afficher après sa dépublication depuis le back-office.
 *
 * `staleTime` n'est volontairement pas surchargé : le QueryClient global
 * (src/index.js) est en staleTime Infinity, refetchOnMount et refetchOnWindowFocus
 * à false. C'est exactement le comportement voulu — un appel par chargement de
 * page, aucun appel lors des navigations SPA. Une annonce publiée ou dépubliée
 * est donc prise en compte au rechargement de la page.
 */
export const useBandeauAnnonce = () => {
    const isReactSnap = typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

    const { data } = useQuery({
        queryKey: ["bandeau-annonce"],
        queryFn: getBandeauAnnonce,
        enabled: !isReactSnap,
        // Inutile d'insister sur un contenu décoratif (le global est à 1).
        retry: false,
    });

    return data ?? null;
};
